import { FastAverageColor } from "fast-average-color";
import moment from "moment";
import { useEffect, useState } from "react"; // Adicionado useState

export default function MiniBook({ item, handleClickOpen, openPost, handleDismiss }: any) {
    const start = moment(item?.start).format('DD/MM/YYYY');
    const end = moment(item?.finaly).format('DD/MM/YYYY');

    const [gradientColor, setGradientColor] = useState('transparent');
    const [textColor, setTextColor] = useState('#ffffff');

    // Funções auxiliares mantidas conforme seu código
    function hexToRgb(hex: string) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null;
    }

    function darkenHexColor(hex: string, lum: number) {
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        lum = lum || 0;
        let rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    }

    useEffect(() => {
        const imageUrl = item?.books?.img; // Corrigido para item?.books?.img
        const fac = new FastAverageColor();

        if (imageUrl) {
            fac.getColorAsync(imageUrl)
                .then(color => {
                    const mainColor = color.hex;
                    const darkColor = darkenHexColor(mainColor, -0.4);
                    setGradientColor(`linear-gradient(135deg, ${mainColor}, ${darkColor})`);

                    const rgb = hexToRgb(mainColor);
                    if (rgb) {
                        const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b);
                        setTextColor(luminance > 150 ? '#000000' : '#ffffff');
                    }
                })
                .catch(() => {
                    setGradientColor('#f3f4f6');
                    setTextColor('#000000');
                });
        }
    }, [item?.books?.img]);

    return (
        <div className="group relative flex flex-col w-full dark:bg-[#0d2d5f]/30 rounded-[15px] shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 dark:border-slate-800"
            style={{ maxWidth: '350px', minHeight: '320px' }} >

            {/* 1. CONTAINER DA IMAGEM (Usando o gradiente dinâmico gerado) */}
            <div
                className="relative flex justify-center items-center p-6 h-[200px] transition-colors duration-700"
                style={{ background: gradientColor }}
            >
                <img
                    src={item?.books?.img}
                    alt={item?.books?.title}
                    className="h-full object-contain shadow-[0_10px_25px_rgba(0,0,0,0.4)] group-hover:scale-110 transition-transform duration-500 rounded-sm z-10"
                />

                {/* Status Badge com cor de texto inteligente */}
                <div className="absolute top-3 left-3 right-3 z-20">
                    <div className="flex items-center justify-between px-3 py-1.5 bg-white/20 backdrop-blur-md rounded-xl border border-white/30 shadow-sm">
                        <span
                            className={`text-[9px] font-semibold px-2 py-0.5 rounded-full uppercase tracking-tighter shadow-sm ${item?.status === 'Reservado' ? 'bg-blue-600' : 'bg-emerald-600'}`}
                            style={{ color: '#ffffff' }} // Badge costuma manter branco para ícone de status, mas variável textColor pode ser usada em títulos se desejar
                        >
                            {item?.status}
                        </span>
                    </div>
                </div>
            </div>

            {/* 2. RODAPÉ DE INFORMAÇÕES (Fundo sólido para garantir leitura) */}
            <div className="p-4 bg-white dark:bg-[#2d3d5780]  border-t border-gray-100 dark:border-slate-500 flex flex-col justify-between flex-1">
                <div>
                    <h3 className="font-bold text-slate-800 dark:text-white text-sm leading-tight truncate capitalize mb-1" title={item?.books?.title}>
                        {item?.books?.title}
                    </h3>
                    <p className="text-[11px] text-slate-500 dark:text-slate-400 font-medium truncate capitalize tracking-wide mb-3">
                        {item?.books?.autor}
                    </p>

                    <div className="grid grid-cols-2 gap-2 py-2 border-t border-gray-50 dark:border-slate-500">
                        {/* Coluna 1 */}
                        <div className="flex flex-col items-center text-center pt-2">
                            <span className="md:text-[8px] text-xs text-gray-400 font-bold uppercase tracking-wider">
                                Retirada
                            </span>
                            <span className="md:text-[10px] text-xs font-bold text-slate-700 dark:text-gray-200">
                                {start}
                            </span>
                        </div>

                        {/* Coluna 2 */}
                        <div className="flex flex-col items-center text-center pt-2">
                            <span className="md:text-[8px] text-xs text-gray-400 font-bold uppercase tracking-wider">
                                {item?.status === 'Entregue' ? 'Entrega' : 'Prazo'}
                            </span>
                            <span className="md:text-[10px] text-xs font-bold text-slate-700 dark:text-gray-200">
                                {end}
                            </span>
                        </div>
                    </div>
                </div>

                {/* 3. BOTÕES DE AÇÃO */}
                {item?.status !== 'Entregue' && (
                    <div className="flex gap-2 mt-3 pt-2">
                        {openPost && (
                            <button
                                onClick={() => handleClickOpen(item?.books?.id)}
                                className="flex-1 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-[9px] uppercase tracking-widest rounded-lg transition-all active:scale-95 shadow-md shadow-indigo-500/20"
                            >
                                Publicar
                            </button>
                        )}
                        <button
                            onClick={() => handleDismiss(item?.id)}
                            className="flex-1 py-2 bg-slate-100 dark:bg-white/10 text-slate-600 dark:text-white font-bold text-[9px] uppercase tracking-widest rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700 transition-all active:scale-95"
                        >
                            Devolver
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}